import React from "react";

export const BannerBadge = ({ label }) => {
  return <div className="banner-badge">{label}</div>;
};
